<template>
	<div class="vx-row">

		<!-- MULTIPLE COLUMNS-->
		<div class="vx-col w-full mb-base">
			<vx-card title="ویرایش پروفایل" @keydown.enter="updateProfile()">
				<div class="vx-row">
				<div class="vx-col sm:w-1/4 w-full mb-2">
						<vs-input
							v-validate="'required'"
							data-vv-validate-on="blur"
							name="name"
							class="w-full"
							icon-pack="feather"
							icon="icon-smartphone"
							icon-no-border
							label-placeholder="نام"
							v-model="adminInfo.name"
						/>
						<span class="text-danger text-sm">{{ errors.first('name') }}</span>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2">
						<vs-input
							v-validate="'required'"
							data-vv-validate-on="blur"
							name="last_name"
							class="w-full"
							icon-pack="feather"
							icon="icon-smartphone"
							icon-no-border
							label-placeholder="نام خانوادگی"
							v-model="adminInfo.last_name"
						/>
						<span class="text-danger text-sm">{{ errors.first('last_name') }}</span>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2">
						<vs-input
							v-validate="'required|min:11|max:11'"
							data-vv-validate-on="blur"
							name="phone_number"
							class="w-full"
							icon-pack="feather"
							icon="icon-smartphone"
							icon-no-border
							label-placeholder="شماره موبایل"
							v-model="adminInfo.phone_number"
						/>
						<span class="text-danger text-sm">{{ errors.first('phone_number') }}</span>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2">
						<vs-input
							v-validate="'required|email'"
							data-vv-validate-on="blur"
							name="email"
							class="w-full"
							icon-pack="feather"
							icon="icon-mail"
							icon-no-border
							label-placeholder="ایمیل"
							v-model="adminInfo.email"
						/>
						<span class="text-danger text-sm">{{ errors.first('email') }}</span>
					</div>
					<!-- <div class="vx-col sm:w-1/3 w-full mb-2">
						<vs-input
							v-validate="'required'"
							data-vv-validate-on="blur"
							name="password"
							class="w-full"
							icon-pack="feather"
							icon="icon-lock"
							icon-no-border
							label-placeholder="رمز عبور"
							v-model="adminInfo.password"
						/>
						<span class="text-danger text-sm">{{ errors.first('password') }}</span>
					</div> -->
				</div>
                <div class="vx-row">
					
				</div>

				<div class="vx-row mt-4">
					<div class="vx-col w-full">
						<vs-button class="mr-3 mb-2" @click="updateProfile()" :disabled="!validateForm">ثبت</vs-button>
						<!-- <vs-button color="danger" type="border" class="mb-2" @click="$router.push('/').catch(() => {})" >انصراف</vs-button> -->
					</div>
				</div>
        
			</vx-card>
		</div>
	</div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
  	custom: {
		name: {
			required: 'وارد کردن نام الزامی است.*',
		},
		last_name: {
			required: 'وارد کردن نام خانوادگی الزامی است.*',
		},
		phone_number: {
			required: 'وارد کردن شماره موبایل الزامی است.*',
			min: "شماره موبایل نمی تواند کمتر از 11 رقم باشد.",
			max: "شماره موبایل نمی تواند بیشتر از 11 رقم باشد.",
		},
		email: {
			required: 'وارد کردن ایمیل الزامی است.*',
			email: "فرمت وارد شده صحیح نمی باشد."
		},
		password: {
			required: 'وارد کردن رمز عبور الزامی است.*',
		}
  	}
}
// register custom messages
Validator.localize('en', dict);

export default{
	components: {
	},

	data() {
		return {
			password: null,
			adminInfo: {
				name: '',
				last_name: '',
				phone_number: '',
				email: '',
				// city: '',
				// birth_date: '',
			},
		}
	},

	computed: {
		validateForm() {
      		return !this.errors.any();
    	},
	},

    created() {
		this.$vs.loading()
		this.$store.dispatch('getAdminInfo')
		.then((res) => {
			this.adminInfo = res.data
			this.$vs.loading.close()
		}).catch(() => {
			this.$vs.loading.close()
			this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
			})
		})
	},

	methods: {
		updateProfile(){
			this.$vs.loading()
			this.$store.dispatch('updateProfile' , this.adminInfo)
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'اطلاعات با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'اطلاعات ارسالی صحیح نمی باشد.',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		}
	}
}
</script>

<style scop>
.day-box:hover ,.month-box:hover ,.year-box:hover , .chosen-day, .chosen-month, .chosen-year{
    color: #fff!important;
}

.day-name:hover{
    color: #000!important;
}

.pdatepicker input{
	border: none!important;
	text-align: left!important;
	width: 260px!important;
}
</style>
